import { schema } from 'normalizr';

const { Entity } = schema;
// Entity(key, definition = {}, options = {})

const submitterId = new Entity('submitterId');

const submitterTargetName = new Entity('submitterTargetName');

const submitter = new Entity('submitters', {
  targetName: submitterTargetName,
  id: submitterId,
});

export const events = new Entity('events', {
  submitter,
});

export const arrayOfEvents = [events];
